const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.9997 1.33301H2.99967C2.0792 1.33301 1.33301 2.0792 1.33301 2.99967V12.9997C1.33301 13.9201 2.0792 14.6663 2.99967 14.6663H12.9997C13.9201 14.6663 14.6663 13.9201 14.6663 12.9997V2.99967C14.6663 2.0792 13.9201 1.33301 12.9997 1.33301ZM13.6663 12.9997C13.6663 13.3679 13.3679 13.6663 12.9997 13.6663H2.99967C2.63148 13.6663 2.33301 13.3679 2.33301 12.9997V11.273L6.16634 7.37301L9.15967 10.373L7.63301 11.9997C7.43804 12.1949 7.43804 12.5111 7.63301 12.7063C7.72583 12.7915 7.84704 12.839 7.97301 12.8397C8.11217 12.8397 8.24504 12.7817 8.33967 12.6797L11.8063 8.99301L13.6397 10.993L13.6663 12.9997ZM12.1997 7.91301L13.6663 9.49301V2.99967C13.6663 2.63148 13.3679 2.33301 12.9997 2.33301H2.99967C2.63148 2.33301 2.33301 2.63148 2.33301 2.99967V9.83967L5.80634 6.29967C6.00155 6.10471 6.3178 6.10471 6.51301 6.29967L9.84634 9.63301L11.4663 7.91301C11.561 7.81095 11.6938 7.75294 11.833 7.75294C11.9722 7.75294 12.1051 7.81095 12.1997 7.91301ZM10.6663 3.33301C9.74587 3.33301 8.99967 4.0792 8.99967 4.99967C8.99967 5.92015 9.74587 6.66634 10.6663 6.66634C11.5868 6.66634 12.333 5.92015 12.333 4.99967C12.333 4.55765 12.1574 4.13372 11.8449 3.82116C11.5323 3.5086 11.1084 3.33301 10.6663 3.33301ZM9.99967 4.99967C9.99967 5.36786 10.2982 5.66634 10.6663 5.66634C11.0345 5.66634 11.333 5.36786 11.333 4.99967C11.333 4.63148 11.0345 4.33301 10.6663 4.33301C10.2982 4.33301 9.99967 4.63148 9.99967 4.99967Z",
  fill: "#8FB0D4"
});

const SvgUploadImage = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUploadImage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/upload-image.f843bd7d.svg";
export { ForwardRef as ReactComponent };